import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

import { ReactComponent as TextSvg } from "@/svgs/text.svg?react";

export default function TextIcon(props: SvgIconProps) {
	return <SvgIcon {...props} component={TextSvg} inheritViewBox />;
}
